export default {
  NONE: 'ErrorStates.NONE',
  LOADING: 'ErrorStates.LOADING',
  REMOVING: 'ErrorStates.REMOVING',
  ADDING: 'ErrorStates.ADDING',
};



/** WEBPACK FOOTER **
 ** ./apps/storePages/cartDropdown/lib/errorStates.js
 **/